<ng-template #Loading>
  <app-loading></app-loading>
</ng-template>
<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Release Notes</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onClose()"
  ></button>
</div>

<ng-template #Loading>
  <app-loading></app-loading>
</ng-template>

<div *ngIf="featuresByMonth.length > 0; else Loading" class="modal-body">
  <button
    *ngIf="isVersionPending"
    type="button"
    class="btn btn-success mb-3"
    (click)="updateVersion()"
  >
    Update to latest version
  </button>

  <ng-container *ngFor="let monthFeatures of featuresByMonth">
    <h3>{{ monthFeatures.month | aadate: 'MMMM YYYY' }}</h3>
    <ul>
      <li
        *ngFor="let feature of monthFeatures.features"
        [class.text-body-secondary]="feature.status === 'PENDING'"
      >
        <ng-container [ngSwitch]="feature.status">
          <ng-template ngSwitchCase="NEW">
            <strong class="badge bg-secondary">New</strong>
          </ng-template>
          <ng-template ngSwitchCase="PENDING">
            <em>(Pending)</em>
          </ng-template>
        </ng-container>
        {{ feature.description }}
      </li>
    </ul>
  </ng-container>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="onClose()">
    Close
  </button>
</div>
